module.exports = __webpack_public_path__ + "static/img/guancun.0e1a78e6.jpg";